<template>
  <ElAlert type="info" class="used-features-and-libraries">
    <header slot="title" class="used-features-and-libraries__title">
      <i class="el-icon-info" />
      <span>{{ $t('INFO') }}</span>
    </header>

    <span>{{ $t('APP.FEATURES_&_LIBRARIES.INTRO') }}</span>

    <template v-if="features.length">
      <span>{{ $t('APP.FEATURES_&_LIBRARIES.FEATURES') }}</span>
      <ul class="used-features-and-libraries__list">
        <li v-for="feat in features" :key="feat" class="text-latin">
          {{ feat }}
        </li>
      </ul>
    </template>

    <span v-if="features.length && libraries.length">{{ $t('AND') }}</span>

    <template v-if="libraries.length">
      <span>{{ $t('APP.FEATURES_&_LIBRARIES.LIBRARIES') }}</span>
      <ul class="used-features-and-libraries__list">
        <li v-for="lib in libraries" :key="lib" class="text-latin">
          {{ lib }}
        </li>
      </ul>
    </template>

    <span>{{ $t('APP.FEATURES_&_LIBRARIES.ENDING') }}</span>
  </ElAlert>
</template>

<script>
export default {
  name: 'UsedFeaturesAndLibraries',
  props: {
    features: {
      type: Array,
      default: () => [],
    },
    libraries: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style lang="scss">
.used-features-and-libraries {
  font-size: 0.8rem;

  &__title {
    font-size: 1rem;
    margin-bottom: $global-margin / 2;

    .el-icon-info {
      vertical-align: middle;
    }
  }

  &__list {
    list-style-position: inside;
    margin: $global-margin * 0.5 0;
    font-weight: 400;
  }
}
</style>
